export default "__VITE_ASSET__AL4c4d66__"